// extracted by mini-css-extract-plugin
export default {"Calculation":"Calculation_Calculation__jM4QU","CalculationInputs":"Calculation_CalculationInputs__7-Gzd"};